import { MembershipRoleEnum } from "../../types/memberships"

export const isLimitedMember = (membership: { role?: string }): boolean => {
  return membership.role === MembershipRoleEnum.orgLimitedMember
}

export const isNormalMember = (membership: { role?: string }): boolean => {
  return membership.role === MembershipRoleEnum.orgMember
}
